import React from 'react';
import {Table} from 'semantic-ui-react';
import { NoData } from "../../components/table/no-data";

class EnvironmentCommentaryTableRow extends React.Component {
    state = { 
        utility: 'Gas', 
        loadingread:true ,

        address : "",
        serialnumber : "",
        ref : "",
        propertyname : "",
        lastreading : "",
        lastreadtype : "",
        datelastread : "",
        description : "",
       
        metersCount: {},
        completenessData: []

    }


    getMeterRead  = (customerId, meterSiteKey) => {
    
    }
  
    render() {
        return (
            <Table.Row>
                <Table.Cell>{this.props.data.fldPeriod || <NoData />}</Table.Cell>
                <Table.Cell>{this.props.data.fldYear || <NoData />}</Table.Cell>
                <Table.Cell>{this.props.data.utility || <NoData />}</Table.Cell>
                <Table.Cell style={{wordBreak:"break-all"}} >{this.props.data.comment || <NoData />}</Table.Cell>
         
            </Table.Row>
        );
    }
}

export default EnvironmentCommentaryTableRow;